import { SELECT_ATTRIBUTE } from '@/appComponents/workbench/targetDefinition/store/actions'

export default {
  props: {
    attribute: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isSelected () {
      // TODO: remove hook to store
      let isAttributeSelected = this.$store.getters['workbench/isAttributeSelected']
      return isAttributeSelected ? isAttributeSelected(this.attribute) : false
    }
  },
  methods: {
    select (attribute) {
      if (!this.disabled) {
        this.$store.dispatch('workbench/' + SELECT_ATTRIBUTE, attribute)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/targetDefinition/components/targetDefinitionStatement/SelectableMixin.js